module.exports = __webpack_public_path__ + "img/1.72e260e7.png";